/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgFirewallRules = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.5 2l.5-.5h5.5L8 2v3l-.5.5H5.149v2.032L6.08 6.6l.566.566-1.897 1.897L2.85 7.166l.566-.566.932.932V5.5H2L1.5 5V2zM7 4.5v-2H2.5v2H7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 14h12l.5-.5v-9L14 4h-3.25l-.5.5V7H8.5l-.5.5V10H2l-.5.5v3l.5.5zm.5-3h2.25v2H2.5v-2zm3.25 2v-2h4.5v2h-4.5zm7.75-5H9v2h4.5V8zm0-1V5h-2.25v2h2.25zm-2.25 4h2.25v2h-2.25v-2z"
})));

export default SvgFirewallRules;